import { render } from "./i-tel.vue?vue&type=template&id=2bab7517"
import script from "./i-tel.vue?vue&type=script&lang=js"
export * from "./i-tel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__